module.exports = __webpack_public_path__ + "img/slider1.074c7b07.jpg";